<template>
  <picture
    ><source :srcset="webpSrcset" :sizes="sizes" type="image/webp" />
    <source :srcset="srcset" :sizes="sizes" />
    <img :alt="altText" :src="imgSrc" :width="largeWidth" />
  </picture>
</template>

<script>
export default {
  name: "Image",
  props: {
    imageUrl: String,
    smallWidth: Number,
    mediumWidth: Number,
    largeWidth: Number,
    altText: String,
  },
  data: function () {
    return {
      webpSrcset: "",
      srcset: "",
      sizes: "",
      imgSrc: "",
    };
  },
  created() {
    this.setupImage();
  },
  methods: {
    setupImage() {
      this.imgSrc = `${this.imageUrl}?width=${this.largeWidth}&amp;quality=90`;
      this.sizes = `(max-width: 767px) ${this.smallWidth}px, (max-width: 991px) ${this.mediumWidth}px, ${this.largeWidth}px`;
      this.webpSrcset = this.generateSrcSet(true);
      this.srcset = this.generateSrcSet(false);
    },
    generateSrcSet(webp) {
      let format = "";
      if (webp) {
        format = "&amp;format=webp";
      }

      const sizes = [this.smallWidth, this.mediumWidth, this.largeWidth];
      const distinctSizes = [...new Set(sizes)];

      let srcset;
      switch (distinctSizes.length) {
        case 1:
          srcset = `${this.imageUrl}?width=${this.smallWidth}${format}&amp;quality=90 ${this.smallWidth}w`;
          break;
        case 2:
          srcset = `${this.imageUrl}?width=${this.smallWidth}${format}&amp;quality=90 ${this.smallWidth}w,
        ${this.imageUrl}?width=${this.mediumWidth}${format}&amp;quality=90 ${this.mediumWidth}w`;
          break;
        case 3:
          srcset = `${this.imageUrl}?width=${this.smallWidth}${format}&amp;quality=90 ${this.smallWidth}w,
        ${this.imageUrl}?width=${this.mediumWidth}${format}&amp;quality=90 ${this.mediumWidth}w,
        ${this.imageUrl}?width=${this.largeWidth}${format}&amp;quality=90 ${this.largeWidth}w`;
          break;
      }

      return srcset;
    },
  },
  watch: {
    imageUrl: {
      handler() {
        this.setupImage();
      },
    },
  },
};
</script>
